/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- ADD-ON TYPES COMMUNITY COLOR SCHEME: STYLES --------------- ++++++++++ */
export default theme => ({
    colorscheme: {
        '& .sectioncontent': {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%',
            marginTop: pxToRem(16),
            '& .reset': {
                display: 'none !important'
            },
            '& .specialcolors': {
                marginTop: pxToRem(48)
            },
            '& h4': {
                marginTop: pxToRem(48),
                marginBottom: pxToRem(16)
            },
            '& .colorpicker': {
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                marginBottom: pxToRem(16),
                '& .picker': {
                    '&.active': {
                        left: 'auto',
                        marginTop: pxToRem(8)
                    }
                },
                '& .swatch': {
                    minWidth: pxToRem(48),
                    marginRight: pxToRem(8)
                },
                '& .currentcolor': {
                    flexWrap: 'wrap',
                    '& .invalidColor': {
                        width: '100%',
                        position: 'relative',
                        left: pxToRem(55),
                        marginTop: pxToRem(4)
                    }
                }
            }
        }
    },

    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: { 
		colorscheme: {
			'& .sectioncontent': {
                '& .colorpicker': {
                    width: '100%',
                    '& .colorpickerlabel': {
                        width: '100%'
                    },
                    '& .currentcolor': {
                        '& .field': {
                            flexBasis: '55%'
                        },                       
                        '& .invalidColor': {
                            left: 0
                        }
                    }
                }
			}
		}
	}
});
